import {
  FETCH_SPONSORS_PENDING,
  FETCH_SPONSORS_FULFILLED,
  FETCH_SPONSORS_REJECTED,
} from "../../constants/sponsors";

const initialState = { loading: false, error: false, success: false, data: null };

const sponsors = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SPONSORS_PENDING:
      return { ...state, loading: true, error: false, success: false, data: state.data ?? null };
    case FETCH_SPONSORS_REJECTED:
      return { ...state, loading: false, error: true, success: false, data: null };
    case FETCH_SPONSORS_FULFILLED: {
      const list = action.payload.data?.sponsors || [];
      const byId = list.reduce((acc, sponsor) => {
        acc[sponsor.sponsorId] = sponsor;
        return acc;
      }, {});
      return { ...state, loading: false, error: false, success: true, data: byId };
    }
    default:
      return state;
  }
};

export default sponsors;
